import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ErrorBoundary } from "@/components/ErrorBoundary";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import Studio from "@/pages/Studio";
import BrandKitPublic from "@/pages/BrandKitPublic";
import MarketingLanding from "@/pages/MarketingLanding";
import AboutUs from "@/pages/AboutUs";
import OnboardingEntry from "@/pages/OnboardingEntry";
import Pricing from "@/pages/Pricing";

function AuthLoading() {
  return (
    <div className="lightboard" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }} data-testid="auth-loading">
      <Loader2 size={26} className="spin" style={{ color: "var(--orange)" }} />
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <AuthLoading />;
  return user ? children : <Navigate to="/login" replace />;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <AuthLoading />;
  return user ? <Navigate to="/app" replace /> : children;
}

function App() {
  return (
    <div className="App">
      <ErrorBoundary>
        <AuthProvider>
          <TooltipProvider delayDuration={150}>
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<MarketingLanding />} />
                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/start" element={<OnboardingEntry />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
                <Route path="/kit/:shareId" element={<BrandKitPublic />} />
                <Route path="/app" element={<Protected><Studio /></Protected>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </BrowserRouter>
            <Toaster position="bottom-right" theme="dark" />
          </TooltipProvider>
        </AuthProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
